import React from 'react'
import ImageCircle from "../../../../components/ImageCircle";
import SocialPublishingStore from "../../store/SocialPublishingStore";

export const SchedulePageSummary = ({schedule, style, ...props}) => {
  const {provider, chatterUserAccountId} = schedule;
  const socialAccounts = SocialPublishingStore.getAccountsForProvider(provider);
  const scheduleAccount = socialAccounts.filter(acc => chatterUserAccountId === acc.id) || [];

  const src = scheduleAccount.length && scheduleAccount[0].imageUrl;
  const name = scheduleAccount.length && scheduleAccount[0].remoteAccountName;

  return (
    <div style={{...style, margin: '10px 0'}} {...props}>
      <ImageCircle size={30} src={src} style={{verticalAlign: 'middle'}}/>
      <span style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: '10px'}}>{name}</span>
    </div>
  );
};
